import Vue from "vue";
import Vuetify from "vuetify/lib";
import fa from "vuetify/lib/locale/fa";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { fa },
    current: "fa",
    rtl: {
      fa: true,
    },
  },

  rtl: true,
  theme: {
    themes: {
      light: {
        primary: "#F6B11E",
        secondary: "#343434",
        third: "#F0F0F0",
        adminPrimary:'#dcb067',
        greyColor: "#e8e8e8",

      },
    },
  },
});
